// Centralized configuration for Cross Training / Skill Tracker report
// Used to drive the data grid column order and the customizable filter controls.

export const tableTemplate = [
  { field: "employee_id", headerName: "Employee ID" },
  { field: "training_type", headerName: "Training Type" },
  { field: "resource_name", headerName: "Resource Name" },
  { field: "grade", headerName: "Grade" },
  { field: "current_skill_group", headerName: "Current Skill Group" },
  { field: "current_skill", headerName: "Current Skill" },
  { field: "sef", headerName: "SEF" },
  { field: "trained_skill_group", headerName: "Trained Skill Group" },
  { field: "trained_on", headerName: "Trained On" },
  { field: "new_sef", headerName: "New SEF" },
  { field: "date_trained", headerName: "Date Trained" },
  { field: "training_month", headerName: "Training Month" },
  { field: "target_account", headerName: "Target Account" },
  { field: "status", headerName: "Status" },
  { field: "fulfillment_grade", headerName: "Fulfillment Grade" },
  { field: "comments", headerName: "Comments" },
  { field: "last_updated_on", headerName: "Last Updated On" },
  { field: "last_updated_by", headerName: "Last Updated By" },
];

// Fields available as customizable filters, and also used as the grouping
// dimensions for the graphical (chart) view.
export const filterTemplate = [
  { field: "training_type", headerName: "Training Type" },
  { field: "training_month", headerName: "Training Month" },
  { field: "current_skill_group", headerName: "Current Skill Group" },
  { field: "trained_skill_group", headerName: "Trained Skill Group" },
  { field: "sef", headerName: "SEF" },
  { field: "grade", headerName: "Grade" },
  { field: "status", headerName: "Status" },
];

// Fields charted in the graphical view. `chartType` drives whether the field
// is rendered as a bar chart, a line chart, or a pie/donut chart.
export const chartTemplate = [
  { field: "current_skill_group", headerName: "Current Skill Group", chartType: "bar" },
  { field: "trained_skill_group", headerName: "Trained Skill Group", chartType: "bar" },
  { field: "training_month", headerName: "Training Month", chartType: "line" },
  { field: "training_type", headerName: "Training Type", chartType: "pie" },
  { field: "sef", headerName: "SEF", chartType: "pie" },
  { field: "grade", headerName: "Grade", chartType: "pie" },
];

export default {
  tableTemplate,
  filterTemplate,
  chartTemplate,
};
